import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { LzLogModule } from "../lz-log/lz-log.module";
import { TranslateModule } from "@ngx-translate/core";

import { LzUserService } from "./services/lz-user.service";
import { LzUserServiceV2 } from './services/lz-user.serivce.v2';
import { LzAuthNewComponent } from "./components/lz-auth-new/lz-auth-new.component";
import { LzRegNewComponent } from "./components/lz-reg-new/lz-reg-new.component";
import { NgxCaptchaModule } from 'ngx-captcha';
import { LzWelcomeComponent } from "./components/lz-welcome/lz-welcome.component";
import { LzRemindNewComponent } from "./components/lz-remind-new/lz-remind-new.component";
import { SharingModule } from "../lz-sharing/sharing.module";
import { TextMaskModule } from "angular2-text-mask";

@NgModule({
  declarations: [
    LzAuthNewComponent,
    LzRegNewComponent,
    LzWelcomeComponent,
    LzRemindNewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    ReactiveFormsModule,
    LzLogModule,
    SharingModule,
    NgxCaptchaModule.forRoot(),
    TextMaskModule,
    TranslateModule
  ],
  providers: [
    LzUserService,
    LzUserServiceV2,
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    }
  ],
  entryComponents: [
    LzAuthNewComponent,
    LzRegNewComponent,
    LzWelcomeComponent,
    LzRemindNewComponent
  ]
})

export class LzUserModule {}
